<template>
  <div class="topic_content">
  <div class='top'>
    <div class='topic_top_right'><label class='topic_top_text'>第{{title_nums}}题</label></div>
    <div class='topic_top_left' style="background-size:250px 100px">
      <label class='level_text'>{{gold_total_nums}}</label>
    </div>
  </div>

  <div class="topic">
    <div class="topic_left"></div>
    <div class="topic_center">
      <div><label class="title">{{topic_info.topic_title}}</label></div>
      <div><button  class="btn" @click="choice_button(1)">{{topic_info.topic_choice[0]}}</button></div>
      <div><button  class="btn" @click="choice_button(2)">{{topic_info.topic_choice[1]}}</button></div>
      <div><button  class="btn" @click="choice_button(3)">{{topic_info.topic_choice[2]}}</button></div>
      <div><button  class="btn" @click="choice_button(4)">{{topic_info.topic_choice[3]}}</button></div>
    </div>
    <div class="topic_right">
      <div class="hint_button"><input type="button" class='hit_button'  @click='hint_button' value="提示"></div>
    </div>
  </div>

    <!-- 遮罩层 -->
    <div class="mask_background" v-show="isShow">
      <div class="mask_info_background">
        <div style='width:100%;height:60%;'>
          <div class="mask_info_text"><label>{{answer_info}}</label></div>
          <div class="mask_info_text"><label>{{add_gold}}</label></div>
        </div>
        <div style='display: flex;align-items:center;justify-content: center;'>
          <input type="button" class='mask_button' @click="next_button" value="下一关"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Toast from './toast/toast.js'
  import {topic_array,get_topic_info} from './common.js'
  import storage from './storage.js'


    export default{
        name:"user",
        data: function(){
          return {
            topic_id:0,
          title_nums: 1,
          gold_total_nums: 30,
          topic_info: {
            "topic_title": 1,
            "topic_choice": [1, 2, 3, 4],
            "topic_answer": 3,
          },
          //题目数据
          topic_array: topic_array,

          //显示结果
          show:'none',
          add_gold:'得到1个金币',
          //回答正确
          answer_info:'回答正确',
            isShow:false,
        }
        },

      created:function(){
         //this.$data.msg="111111";
        this.topic_array = topic_array;

        this.part_total_nums = this.topic_array.length;
        console.log("---",this.part_total_nums)
        this.title_nums = 1;
        this.gold_total_nums=30;
        this.show='none';

        this.topic_id = storage.getItem("part_current_id");
        //console.log("---",this.topic_id)
        if(this.topic_id==null || this.topic_id == undefined)
        {
          this.topic_id = 0;
          storage.setItem("part_current_id",this.topic_id)
          //console.log("---",this.topic_id)
        }
        this.title_nums = parseInt(this.topic_id)+1;
        this.topic_info=get_topic_info(this.topic_id);


        this.gold_total_nums = this.get_gold_total_nums();
      },

      methods: {
        choice_button: function (index) {
          //正确
          if (index == this.topic_info.topic_answer) {
            console.log("ok");

            this.isShow = true;
            this.topic_id++;

            //增加金币数
            this.gold_total_nums = parseInt(this.gold_total_nums)+1;
            this.set_gold_total_nums(this.gold_total_nums);

            //等于总关数
            if(this.topic_id == this.part_total_nums)
            {
              this.answer_info = '居然到最后一道了，牛';
              this.show = 'flex';
            }
            else
            {
              this.title_nums++;
              this.show = 'flex';

              this.set_part_id(this.topic_id);
            }
          }
          else {

          }
        },

        //提示按钮
        hint_button:function(){
          var _this = this;
          //减掉金币
          var gold_tmp = this.gold_total_nums-30;

          if (gold_tmp>=0)
          {
            _this.gold_total_nums = gold_tmp;
            this.$forceUpdate();
            Toast({
              message : "正确",
              position: 'center',
              duration : 1000
            })

            //this.set_gold_total_nums(this.gold_total_nums);
            //_this.$set(this.gold_total_nums,this.gold_total_nums);
            //console.log("---",this.gold_total_nums)

            //return this.gold_total_nums;
            /*
            //提示
            prompt.showToast({
              message: '答案：' + this.topic_info.topic_choice[1],
              duration: 1
            })
            */
          }
          else
          {
            console.log("000");
            Toast({
              message : "错误",
              position: 'top',
              duration : 1000
            })

            /*
            //提示分享
            prompt.showToast({
              message: '需要30个金币',
              duration: 1
            })
            */

          }

        },


        //下一关
        next_button:function()
        {
          //下一关
          if (this.topic_id < this.part_total_nums)
          {
            //得到新数据
            this.topic_info = get_topic_info(this.topic_id);
            //this.topic_hint = this.topic_info.topic_explain;

            //this.topic_answer = this.topic_info.topic_title
            //this.topic = this.topic_info.topic_title.split("");
            //this.topic_answer_array = this.topic_info.topic_title.split("");
            //this.get_rand_array();

            this.title_nums = this.topic_id;
            this.title_nums++;

            //this.init_topic_disabled();
            //this.init_answer_array();

            //隐藏mask
            this.show='none';
            this.isShow = false;

          }
          else{

            // 返回上一页面
            //router.back()
          }
          this.$forceUpdate();
        },


        //设置当前关卡
        set_part_id:function(part_id)
        {
          storage.setItem('part_current_id',part_id)
        },

        //得到总金币数
        get_gold_total_nums:function()
        {
          this.gold_total_nums =  storage.getItem('gold');
          console.log('777',this.gold_total_nums)
          if(this.gold_total_nums == 'null' || this.gold_total_nums==''||this.gold_total_nums==NaN||this.gold_total_nums==undefined) {
            this.gold_total_nums = 30;
          }
          console.log("888",this.gold_total_nums)
          return this.gold_total_nums;
        },

        //设置总金币数
        set_gold_total_nums:function(gold_total_nums)
        {
          storage.setItem('gold',gold_total_nums);
        },
      }
    }
</script>
<style scoped>
  .topic_content{
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .top{
  width: 100%;
  height: 100px;
  display: flex;
  align-items:center;
  justify-content: space-between;
  background-color:#304C4F;
}
.top .topic_top_text{
  font-size: 50px;
}
.top .topic_top_left{
  width:250px;
  height:100px;

  align-items:center;
  display:flex;
  justify-content:center;
  background-image: url('../assets/gold.png');
}
  .top .topic_top_right{
    width:50%;
    height:100px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .top .level_text{
    color: #ffffff;
    margin-left: 80px;
    font-size: 50px;
  }


  .topic{
    width: 100%;
    display: flex;
    flex-direction:row;
    justify-content:flex-start;
    align-items:center;
    margin-top: 50px;
  }
  .topic_left{
    width:20%;
  }
  .topic_right{
    width:20%;
    height: 650px;
    position: relative;
  }
  .topic_center{
    width:60%;
    flex-direction: column;
    justify-content:flex-start;
    align-items:center;
  }

  .title {
    font-size: 50px;
    text-align: center;
    margin-bottom: 50px;
  }

  .btn {
    width: 550px;
    height: 86px;
    margin-top: 75px;
    border-radius: 43px;
    background-color: #09ba07;
    font-size: 40px;
    color: #ffffff;
    margin: 15px;
  }
  .hint_button{
    width: 100%;
    height: 150px;
    position: absolute;        /* 相对于容器绝对定位 */
    bottom: 0px;
  }

  .hit_button{
    width: 150px;
    height: 80px;
    margin-bottom: 50px;
    background-color: #5D86CF;
  }
  /*mask*/
  .mask_background{
    position:fixed;
    width:100%;height:100%;top:0px;
    background-color:rgba(0,0,0,0.4);
    text-align:center;
    justify-content:center;
  }
  .mask_info_background{
    width: 90%;height: 600px;
    background-color: #ffffff;
    border-radius: 20px;
    align-items:center;
    justify-content:center;
    flex-direction: column;
  }
  .mask_info_text{margin:110px 30px 30px 30px;color:#999999;font-size:40px;background-color: #ffffff;padding:0px 30px;text-align: center;}
  .mask_button {
    width: 460px;
    height: 77px;
    background-color: #E94D62;
    border-radius: 38px;
    line-height: 77px;
    color:#ffffff;
    font-size: 32px;
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// User.vue?6f43b3f7